import './components.css'

import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { useUserStore } from '../../store/userStore'

import LoginButtonComponent from './LoginButtonComponent'
import { useSocketStore } from '../../store/socketStore'
import AlertIcon from './AlertIcon'

const Header = () => {
  /* State */
  const { userInfo, logoutAction } = useUserStore((state) => state)
  const { disconnectSocket } = useSocketStore((state) => state)
  const [isLogin, setIsLogin] = useState(userInfo ? true : false)
  const location = useLocation()

  useEffect(() => {
    setIsLogin(userInfo ? true : false)
  }, [userInfo])

  const onClickLogout = () => {
    disconnectSocket()
    logoutAction()
  }

  return (
    <header
      className="navbar navbar-expand-lg navbar-light fixed-top shadow-sm bg-light"
      id="mainNav"
      style={{ padding: '20px 0' }}>
      <div className="container-lg">
        {/* Logo */}
        <Link to={'/'} className="navbar-brand fw-bold">
          <img
            src="https://contents.sixshop.com/uploadedFiles/151941/default/image_1717761076642.png"
            alt="HY교육 로고"
            width={150}
          />
        </Link>

        <div id="buttomWrap" className='d-flex align-items-center'>
          {/* 알림 아이콘 */}
          {isLogin && <div className='me-3'><AlertIcon userInfo={userInfo} /></div>}

          {/* Mobile Menu Button */}
          <button
            className="navbar-toggler collapsed py-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <i className="bi bi-list"></i>
          </button>
        </div>

        {/* GNB */}
        <nav id="navbarResponsive" className="navbar-collapse collapse">
          <ul className="navbar-nav ms-auto me-lg-4 my-3 my-lg-0">
            {/* <li className="nav-item">
              <NavLink to={'/hy-admin'} target='_blank' className="nav-link me-lg-3 py-3">관리자(개발용)</NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink to={'/survey'} className="nav-link me-lg-3 py-3">
                KGS 메가반 상담 신청
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={'/school-record'} className="nav-link me-lg-3 py-3">KGS 생활기록부</NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink to={'/recommend'} className="nav-link me-lg-3 py-3">강의추천</NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink to={'/mypage'} className="nav-link me-lg-3 py-3">
                마이페이지
              </NavLink>
            </li>
          </ul>

          {/* 모바일 - 로그인 버튼 */}
          <div className='d-block d-lg-none'><LoginButtonComponent isLogin={isLogin} onClickLogout={onClickLogout} location={location} /></div>
        </nav>

        {/* PC - 로그인 버튼 */}
        <div id='loginBtnPC' className='d-none d-lg-block'><LoginButtonComponent isLogin={isLogin} onClickLogout={onClickLogout} location={location} /></div>
      </div>
    </header>
  )
}

export default Header
